import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-archive': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M128.3 160h32v32h-32v-32zM192.3 64v32h-32v-32h32zM128.3 96h32v32h-32v-32zM192.3 128v32h-32v-32h32zM369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM256 51.9v76.1h76.1zM336 464v-288h-104c-13.3 0-24-10.7-24-24v-104h-48.3v16h-32v-16h-79.7v416h288zM194.2 265.7l17.3 87.7c6.4 32.4-18.4 62.6-51.5 62.6-33.2 0-58-30.4-51.4-62.9l19.7-97.1v-32h32v32h22.1c5.8 0 10.7 4.1 11.8 9.7zM160.3 390.1c17.9 0 32.4-12.1 32.4-27 0-14.9-14.5-27-32.4-27-17.9 0-32.4 12.1-32.4 27 0 14.9 14.5 27 32.4 27zM192.3 192v32h-32v-32h32z'
      }
    ]
  }
})
